import { render, staticRenderFns } from "./DetalharDados.vue?vue&type=template&id=7929ea1a&scoped=true"
import script from "./DetalharDados.vue?vue&type=script&lang=js"
export * from "./DetalharDados.vue?vue&type=script&lang=js"
import style0 from "./DetalharDados.vue?vue&type=style&index=0&id=7929ea1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7929ea1a",
  null
  
)

export default component.exports